import {withTranslation} from 'react-i18next';

const CWhoContent = (props) => {
    const {t} = props;
    return (<div className="centerStretto">
    {/* <h2 className="alignCenter">{t('common.who')}</h2> */}
        <div className="ch-crs crs-who-background-container alignCenter">
            {/*
            <div className="floatRight pad-r20">
                <img src="/images/ch_left_sorciere.jpg" width="300px" alt="who am I"/>
            </div>
            */}
            <p>
                {t('legal.who.whoP1')}<br/><br/>
                {t('legal.who.whoP2')}<br/><br/>
                {t('legal.who.whoP3')}<br/><br/>
                {t('legal.who.whoP4')}<br/>
                {t('legal.who.whoP5')}<br/><br/>
                {t('legal.who.whoP6')}
            </p>
        </div>
    </div>)
}
export default withTranslation('common')(CWhoContent);